import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "FontAwesome__caret-right",
  "use": "FontAwesome__caret-right-usage",
  "viewBox": "0 0 7 11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 7 11\" id=\"FontAwesome__caret-right\"><path fill=\"#66737D\" d=\"m5.707 6.049-3.75 3.75a.948.948 0 0 1-1.025.205.96.96 0 0 1-.586-.879v-7.5a.92.92 0 0 1 .586-.85.948.948 0 0 1 1.025.205l3.75 3.75c.38.352.38.967 0 1.319Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol